import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "left" }
const _hoisted_2 = { class: "pre-title" }
const _hoisted_3 = { class: "channel-title" }
const _hoisted_4 = { class: "right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_pen_icon = _resolveComponent("pen-icon")!
  const _component_minus_circle_icon = _resolveComponent("minus-circle-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["channel-card", { draft: _ctx.draft, unlink: _ctx.pendingUnlink }]),
    onClick: _cache[1] || (_cache[1] = ($event: any) => (!_ctx.draft && _ctx.$emit('channel-click')))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h4", _hoisted_2, _toDisplayString(_ctx.channel.id), 1),
      _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.channel.name), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_pen_icon, {
        class: "pen-icon card-icon",
        size: "2rem"
      }),
      (!_ctx.pendingUnlink)
        ? (_openBlock(), _createBlock(_component_minus_circle_icon, {
            key: 0,
            class: "circle-icon card-icon",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('unlink')), ["stop"]))
          }))
        : _createCommentVNode("", true)
    ])
  ], 2))
}